import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, CarFront, CalendarCheck, MessageSquare, Clock, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Toaster } from "../../components/ui/sonner";

const ADMIN_NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/cars", label: "Cars For Sale", icon: CarFront },
  { to: "/admin/bookings", label: "Bookings", icon: CalendarCheck },
  { to: "/admin/enquiries", label: "Enquiries", icon: MessageSquare },
  { to: "/admin/settings", label: "Opening Hours", icon: Clock },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/admin");
  };

  return (
    <div data-testid="admin-layout" className="min-h-screen bg-[#081627] flex flex-col lg:flex-row">
      <aside className="lg:w-60 shrink-0 bg-navy border-b lg:border-b-0 lg:border-r border-deep lg:min-h-screen lg:sticky lg:top-0">
        <div className="p-5 border-b border-deep flex items-center justify-between lg:block">
          <div>
            <span className="bg-brand text-white font-heading font-black text-sm px-2 py-0.5 rounded-sm">PR7</span>
            <span className="ml-2 font-heading font-extrabold text-white text-sm tracking-wide">MOT CENTRE ADMIN</span>
          </div>
          <Link to="/" data-testid="admin-view-site" className="lg:hidden text-pale/60 hover:text-sky"><ExternalLink size={18} /></Link>
        </div>
        <nav data-testid="admin-nav" className="flex lg:flex-col overflow-x-auto lg:overflow-visible p-2 lg:p-3 gap-1">
          {ADMIN_NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3.5 py-2.5 rounded text-sm font-semibold whitespace-nowrap transition-colors ${
                  isActive ? "bg-brand text-white" : "text-pale/60 hover:text-white hover:bg-deep/60"
                }`
              }
            >
              <n.icon size={17} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:block absolute bottom-0 w-60 p-3 border-t border-deep">
          <Link to="/" className="flex items-center gap-2.5 px-3.5 py-2 text-sm text-pale/50 hover:text-sky transition-colors">
            <ExternalLink size={15} /> View website
          </Link>
          <div className="px-3.5 py-2 text-xs text-pale/40 truncate">{user?.email}</div>
          <button onClick={doLogout} data-testid="admin-logout-btn" className="flex items-center gap-2.5 px-3.5 py-2 text-sm text-pale/60 hover:text-white transition-colors w-full">
            <LogOut size={15} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <div className="lg:hidden flex justify-end p-3 border-b border-deep bg-navy">
          <button onClick={doLogout} data-testid="admin-logout-mobile" className="inline-flex items-center gap-2 text-sm text-pale/60 hover:text-white">
            <LogOut size={15} /> Sign out
          </button>
        </div>
        <div className="p-4 sm:p-6 lg:p-8">
          <Outlet />
        </div>
      </main>
      <Toaster position="top-center" richColors />
    </div>
  );
}
